// src/hooks/usePageTimeTracking.js
import { useEffect } from "react";
import ReactGA from "react-ga4";

const usePageTimeTracking = (pageName) => {
  useEffect(() => {
    const currentStartTime = Date.now();
    return () => {
      const endTime = Date.now();
      const timeSpent = Math.round((endTime - currentStartTime) / 1000); // tính bằng giây

      ReactGA.event({
        category: "Engagement",
        action: "Time Spent",
        label: pageName,
        value: timeSpent,
      });
    };
  }, [pageName]);
};

export default usePageTimeTracking;
